import { useEffect, useState } from "react";
import { showCustomToast } from "@/shared/components/generic/snackbar/showCustomToast.tsx";
import IconRoundedExclamationMark from "@/shared/components/generic/icons/IconRoundedExclamationMark.tsx";

export default function useShowError(
  showError: boolean,
  message: string,
): void {
  const [showErrorPrev, setShowErrorPrev] = useState(showError);
  const [hasBeenShown, setHasBeenShown] = useState(false);

  useEffect(() => {
    if (showErrorPrev !== showError) {
      // prop value changed
      setShowErrorPrev(showError);
      if (showError) setHasBeenShown(false);
    }
    if (showErrorPrev && !hasBeenShown) {
      showCustomToast({
        message,
        style: "ERROR",
        icon: IconRoundedExclamationMark,
        showCloseIcon: true,
      });
      setHasBeenShown(true);
    }
  }, [hasBeenShown, message, showError, showErrorPrev]);
}
